import { Menu } from 'lucide-react';
import { ClockChip } from './ClockChip';
import { UserAvatarButton } from './UserAvatarButton';

export interface TopbarProps {
  title: string;
  onMenuClick: () => void;
}

export function Topbar({ title, onMenuClick }: TopbarProps) {
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3.5 border-b border-border bg-surface px-4 py-3 md:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="open navigation"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-text-secondary hover:bg-surface-hover md:hidden"
      >
        <Menu size={20} />
      </button>

      <div className="min-w-0">
        <p className="truncate text-base font-bold text-text-primary">{title}</p>
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-primary" />
          <p className="truncate text-xs text-text-secondary">Multi-PERT · Multi-project PERT scheduling</p>
        </div>
      </div>

      <div className="flex-1" />

      <ClockChip />
      <UserAvatarButton />
    </header>
  );
}
